import CaseStudiesCarousel from '@/components/case-studies/case-studies-carousel'
import ServiceTestimonials from '@/components/service/service-testimonials'
import SectionDivider from '@/components/ui/section-divider'

// The complete template already renders case studies before FAQ. Older pages
// receive the same carousel here until their bodies move into that template.
export default function ServiceClosingProof({
  includeCaseStudies = false,
  afterDivider = false,
  compactBottom = false,
  testimonials,
}) {
  return (
    <div
      className={`bg-white px-6 ${compactBottom ? 'pb-16' : 'pb-20 lg:pb-28'} ${afterDivider ? '' : 'pt-20 lg:pt-28'}`}
    >
      <div className="mx-auto max-w-7xl">
        {includeCaseStudies && (
          <>
            <CaseStudiesCarousel />
            <SectionDivider />
          </>
        )}
        <ServiceTestimonials reviews={testimonials} />
      </div>
    </div>
  )
}
